import ManagersList from "./managers/ManagersList";
import EditCompany from "./EditCompany";
import useAuth from "../auth/hooks/useAuth";
import CompanyFeatureToggles from "./CompanyFeatureToggles";
import { Geartest } from "./components/Geartest";
import { EventDiscoveryDefault } from "./components/EventDiscoveryDefault";
import EditLoginOptions from "./components/EditLoginOptions";

const CompanyProfile = (): JSX.Element => {
  const { isManager, isAdmin } = useAuth();

  return (
    <>
      <EditCompany />
      {(!isManager && <ManagersList isEdit />) || null}
      {((isAdmin || isManager) && <CompanyFeatureToggles />) || null}
      {isAdmin && <EditLoginOptions />}
      <Geartest />
      <EventDiscoveryDefault />
    </>
  );
};

export default CompanyProfile;
